import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-index',
  	templateUrl: './toolcards-index.component.html',
  	styleUrls: ['./toolcards-index.component.scss']
})
export class ToolcardsIndexComponent implements OnInit {
	public env;

  	constructor() { }

  	ngOnInit() {
  		this.env=environment;
  	}

}
